import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from 'pages/organisations/companies/v5/hooks/useCompanyForm';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../../constants';

const WholesalerName = ({ darkMode, errors, isAddMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useCompanyForm();

    const handleChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.NAME, e.target.value);
        if (isAddMode) {
            updateFormData(FORM_FIELD_PATHS.ENTITY_NAME, e.target.value);
        }
    };

    const hasError = !!errors?.name;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    {isAddMode ? 'Wholesaler Name' : 'Friendly Wholesaler Name'}{' '}
                    <span style={{ color: '#e53e3e' }}>*</span>
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NameField}
                        id={FORM_FIELD_PATHS.NAME}
                        name={FORM_FIELD_PATHS.NAME}
                        value={formData?.name || ''}
                        onChange={handleChange}
                        placeholder={
                            isAddMode
                                ? 'Wholesaler Name'
                                : 'Friendly Wholesaler Name'
                        }
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                        validate={() => {
                            if (!formData?.name) {
                                return 'Wholesaler name is required';
                            }
                        }}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter the wholesaler name"
                        ariaLabel="wholesaler-name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default WholesalerName;
